import { Grid, useMediaQuery } from '@mui/material';
import React, { ReactNode } from 'react';
import { colors, theme } from '../utils/theme';
import { VideoPlayer } from './VideoPlayer';

const imageExtensions: string[] = ['.png', '.jpg', '.jpeg', '.gif', '.svg'];
const videoExtensions: string[] = ['.mp4', '.avi', '.mov', '.wmv'];

const getMediaType = (src: string): 'image' | 'video' | 'unknown' => {
  for (let ext of imageExtensions) {
    if (src.includes(ext)) {
      return 'image';
    }
  }
  for (let ext of videoExtensions) {
    if (src.includes(ext)) {
      return 'video';
    }
  }
  return 'unknown';
};

export const RootineMediaAndText = ({
  mediaSrc,
  textComponent,
}: {
  mediaSrc?: string;
  textComponent: ReactNode;
}): JSX.Element => {
  const mediaType = mediaSrc && getMediaType(mediaSrc);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Grid
      container
      sx={{
        position: 'relative',
        background: colors.greens.BASE,
        borderRadius: 1.25,
        overflow: 'hidden', // Contain the image/video within this Grid
      }}
    >
      <Grid
        item
        sx={{
          pt: 10,
          pb: 14,
          px: 8,
          width: mediaSrc ? '60%' : '100%',
          [theme.breakpoints.down('md')]: {
            width: '100%',
          },
        }}
      >
        {textComponent}
      </Grid>

      {mediaSrc &&
        (mediaType === 'image' || mediaType === 'video') &&
        !isMobile && (
          <Grid
            item
            sx={{
              position: 'absolute', // Set to absolute so it fills the parent
              top: 0,
              right: 0,
              height: '100%',
              width: '40%',
            }}
          >
            {mediaType === 'image' ? (
              <img
                src={mediaSrc}
                alt=""
                style={{
                  height: '100%',
                  width: '100%',
                  objectFit: 'cover',
                }}
              />
            ) : (
              <VideoPlayer video={mediaSrc} />
            )}
          </Grid>
        )}
    </Grid>
  );
};
